export function getCssPropertyKeyValue(cssString: string) {
  return cssString.split(':').map(i => i.trim());
}

export function isInvalidPositionStyle(name: string, value: string) {
  if (name === 'position') {
    return ['fixed', 'absolute'].includes(value);
  }
}

export function isSafeUrl(url: string): boolean {
  const unsafePatterns = /^(javascript|data):/i;
  return !unsafePatterns.test(url);
}

export function filterBackgroundUrl(styles: string): string {
  return styles.replace(/background\s*:\s*url\((.*?)\)\s*;?/gi, (match, url) => {
    const cleanedUrl = url.replace(/['"]/g, '').trim();

    if (!isSafeUrl(cleanedUrl)) {
      return '';
    }
    return match;
  });
}
